import { render } from "./vueImg.vue?vue&type=template&id=5f8f0257&scoped=true"
import script from "./vueImg.vue?vue&type=script&lang=js"
export * from "./vueImg.vue?vue&type=script&lang=js"

import "./vueImg.vue?vue&type=style&index=0&id=5f8f0257&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8f0257"]])

export default __exports__